import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { StatusExtended } from 'src/app/models/status-extended';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})
export class AlertsComponent {
  private _alerts: Array<StatusExtended>;

  get alerts(): Array<StatusExtended> {
    return this._alerts;
  }

  @Input() set alerts(alerts: Array<StatusExtended>) {
    this._alerts = alerts;
  
    if (this.alerts?.length > 0) {
      this.isAlerts = true;
    }

    this.isLoaded = true;
  }

  @Output() selectAlertEvent = new EventEmitter<StatusExtended>();

  public isLoaded: boolean = false;
  public isAlerts: boolean = false;

  constructor() { }

  selectAlert(alert: StatusExtended) {
    this.selectAlertEvent.emit(alert)
  }

}
